import { useState } from 'react'
import {
  Empty,
  IdInterpretationsBody,
  IdInterpretationsHead,
  NothingFound,
} from './tableComponents'
import Table from '../../../myTable/MyTable'
import styled from 'styled-components'
import { MAX_PER_PAGE } from '../../../../constants/other'
import {EmptyTable} from "../../../../pages/subjects/Subject";

const TableStyle = styled.div<{ hasdata: string }>`
  width: 100%;

  /* height: 600px; */
  /* min-height: 500px; */
  ////overflow:scroll;

  ${({ hasdata }) =>
    hasdata === 'true' && 'border: 1px solid var(--border-main, #ededed);'}

  table {
    /* height: 100%; */
    /* table-layout: fixed; */
    width: 100%;
    border: none;
    border-collapse: collapse;

    td {
      border: none;
      height: fit-content;
      p {
        /* word-wrap: break-word; */
      }
    }

    td:nth-child(1) {
      width: 40%;
    }
    td:nth-child(2) {
      width: 15%;
    }
    td:nth-child(3) {
      width: 15%;
    }
    td:nth-child(4) {
      width: 30%;
    }
  }
`

export const IdInterPretationsTable = ({ data }: any) => {
  // const { recommendations } = useAppSelector((state) => state.data)
  let [filter, setFilter] = useState<any>({
    sort: '_id',
    perPage: MAX_PER_PAGE,
    search: '',
    // direction: 'asc',
    filter: {},
  })
  const hasdata = data?.length > 0 ? 'true' : 'false'

  return (
    <TableStyle hasdata={hasdata}>
      <Table
        Head={IdInterpretationsHead}
        Body={IdInterpretationsBody}
        EmptyItems={() => <EmptyTable name={'signal set'}/>}
        NothingFound={NothingFound}
        apiSearchFileds={['name']}
        onFilter={(it: any, filter: any) => {
          if (filter._id) {
            return it._id == filter._id
          }
          return true
        }}
        onSearch={(it: any, reg: any) => {
          return reg.test(it.name)
        }}
        onChangeFilter={(v: any) => {
          setFilter(v)
        }}
        filter={filter}
        items={data}
      />
    </TableStyle>
  )
}

export default IdInterPretationsTable
